import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "breadCrumbsNavigation" }
const _hoisted_2 = { class: "breadCrumbItem" }
const _hoisted_3 = { href: "https://abb.sharepoint.com/sites/NO-CompetenceLibrary/SitePages/TeamView.aspx" }
const _hoisted_4 = { class: "breadCrumbItem" }




export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
  reportName: String,
},
  setup(__props) {

const props = __props;




return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-house" }),
        _cache[0] || (_cache[0] = _createTextVNode(" U3t "))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "breadcrumb-delimiter" }, "·", -1)),
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-line-chart" }),
      _createTextVNode(" " + _toDisplayString(props.reportName), 1)
    ])
  ]))
}
}

})